// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"547":"cb6bc3ef","861":"c88aafb2"}[chunkId] + ".chunk.css";
};